import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import './_EditIndicator.scss';

type Props = {
    fieldName?: string;
    show: boolean;
};

export default function EditIndicator({ show, fieldName }: Props) {
    const { t } = useTranslation('common');
    const [isShowing, setIsShowing] = useState(false);

    useEffect(() => {
        show ? setIsShowing(true) : setIsShowing(false);
    }, [show]);

    const showClass = isShowing ? 'show' : '';
    return (
        <div className={`EditIndicator ${showClass}`}>
            <p className="copy">{`${t('click_to_edit')} ${fieldName ? fieldName : ''}`}</p>
        </div>
    );
}
